import React from "react";
import IMAGEM from "components/imagem";
import config from "../../config";

const Promocao = ({ promocao, index }) => {
    // Valida se a imagem existe e não é vazia
    const imagemValida = promocao?.imagem && promocao.imagem !== '' && !promocao.imagem.endsWith('/');
    
    return (
        <div key={index} className="promocao-container promocao-card loja-promocao-card">
            {imagemValida && <IMAGEM
                participantes={true}
                src={`${config.BASEIMG}/${promocao.imagem}`}
                width="60%"
            />}
        </div>    
    );
};

export default Promocao;